import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

import {createElement, PropTypes, Component} from 'rlink-react';
import themeable from 'rlink-theme/themeable';
import setBirthday from 'rlink-agegate/setBirthday';

import DaySelector from './DaySelector';
import MonthSelector from './MonthSelector';
import YearSelector from './YearSelector';

export default class AgeGateForm extends Component {
  constructor (props, ...args) {
    super(props, ...args);

    this.state = {
      selectedDay: props.selectedDay,
      selectedMonth: props.selectedMonth,
      selectedYear: props.selectedYear,
    };
  }

  onSubmit (ev) {
    ev.preventDefault();

    let date = new Date(
      this.state.selectedYear,
      this.state.selectedMonth,
      this.state.selectedDay,
    );

    if (!isNaN(date.valueOf())) {
      setBirthday(date);
      window.scrollTo(0, 0);
      this.props.onSubmit();
    }
  }

  render () {
    return (
      <form className={this.props.theme.Form} onSubmit={ev => this.onSubmit(ev)}>
        <h2>{this.props.prompt}</h2>

        <div className={this.props.theme.DateSelect}>
          <DaySelector
            selectedDay={this.state.selectedDay}
            selectedMonth={this.state.selectedMonth}
            selectedYear={this.state.selectedYear}
            onChange={selectedDay => this.setState({selectedDay})} />
          <MonthSelector
            selectedMonth={this.state.selectedMonth}
            onChange={selectedMonth => this.setState({selectedMonth})} />
          <YearSelector
            selectedYear={this.state.selectedYear}
            onChange={selectedYear => this.setState({selectedYear})} />
        </div>
        <button id="age-gate-submit" type="submit">{this.props.submitLabel}</button>

        <footer className={this.props.theme.CookiePolicy}>
          <p>
            <FormattedHTMLMessage
              id="ui.text.description.AGE_GATE_COOKIE_POLICY"
              defaultMessage={'This website would like to store cookies in your browser, one of which is used by this age verification gate in order to ensure that we communicate our products and services responsibly. Without this cookie, you would have to re-submit your date of birth information before every page you want to visit on the website. We do not store any of this personal information. <a href="https://content.relic.com/legal/cookiepolicy.html" rel="noopener" target="_blank">Please see our cookies policy for more details</a>.'}
              description="Cookie placement message appearing on the age verification form." />
          </p>
        </footer>
      </form>
    );
  }
}

AgeGateForm.propTypes = {
  onSubmit: PropTypes.func,
  selectedDay: PropTypes.number,
  selectedMonth: PropTypes.number,
  selectedYear: PropTypes.number,
  submitLabel: PropTypes.string,
  prompt: PropTypes.string,
};

themeable(AgeGateForm, {
  classes: [
    'Form',
    'DateSelect',
    'CookiePolicy',
    'GdprConsentContainer',
    'GdprConsentCheckbox',
    'GdprConsentMessage',
    'AgeGateCookiePolicy',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-agegate/components/AgeGateForm.jsx